

type InterpolationElement = HTMLElement & {
    $componentUpdated?: () => void
    $destroy?: () => void
}

const isInternalLink = (href?: string) => href?.startsWith('/');

const navigate = (event: Event) => {
    const target = event.currentTarget as HTMLElement;
    const href = target.getAttribute('href');
    event.preventDefault();
    return navigateTo(href);
};

const addListeners = (links: HTMLAnchorElement[]) =>
    links.forEach((link) => link.addEventListener('click', navigate, false));

const removeListeners = (links: HTMLAnchorElement[]) =>
    links.forEach((link) => link.removeEventListener('click', navigate, false));

export default defineNuxtPlugin((nuxt) => {
    nuxt.vueApp.directive('interpolate', {
        mounted: (el: InterpolationElement) => {
            const links = Array.from(el.getElementsByTagName('a')).filter((linkEl) => {
                const href = linkEl.getAttribute('href');
                if (!href) return false;
                return isInternalLink(href);
            })
            addListeners(links)
            // cleanup
            el.$componentUpdated = () => {
                removeListeners(links)
                nextTick(() => addListeners(links))
            }
            el.$destroy = () => removeListeners(links)

        },
        updated: (el) => el.$componentUpdated?.(),
        beforeUnmount: (el) => el.$destroy?.()
    })
})